import { useLocation } from 'react-router-dom';
import { AppRoutes } from '@/routes/AppRoutes';
import { ErrorBoundary } from '@/components/ErrorBoundary';

export default function App() {
  const location = useLocation();

  // Keying by pathname remounts the boundary on navigation, so a render
  // error on one page doesn't leave every subsequently-visited page
  // stuck showing the same "Something broke" fallback until a hard reload.
  return (
    <ErrorBoundary key={location.pathname}>
      <AppRoutes />
    </ErrorBoundary>
  );
}
